import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';

import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';

import { MoodEnum } from './MoodEnum';
import styles from './Mood.module.css';

export interface MoodIconComponent extends BaseComponent {
  type: 'moodIcon';
  props: MoodIconProps;
}
export interface MoodIconProps {
  mood: MoodEnum;
  width?: string;
}
export const MoodIcon: React.FC<MoodIconProps> = ({ mood, width }) => {
  return (
    <div
      className={styles[mood]}
      style={{ width: width ?? '', height: width ?? '' }}
    />
  );
};

export const renderMoodIconAction = assign(
  (context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const getValueFrom = actionMetadata.action.payload.getValueFrom;
    const mood = context.userData[getValueFrom];

    newContext.widgetData.push({
      type: 'moodIcon',
      temporary: actionMetadata.action.temporary ?? false,
      props: { mood: mood },
    });
    return newContext;
  }
);
